
export function getCRMStatusPriorityLabel(statusId) {
  const stageClassNames = {
    19301: "High",
    19302: "Medium",
    19303: "Low",
    19304: "Call Back",
  };
  return stageClassNames[statusId] || "";
}
export function getCRMStatusPriorityClassName(statusId) {
  const stageClassNames = {
    19301: "badge bg-danger",//High
    19302: "badge badge-bg-orange",//Medium
    19303: "badge bg-success",//Low
    19304: "badge badge-bg-purple",//Call Back
  };
  return stageClassNames[statusId] || "";
}